import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import SobreNosotros from "./pages/Quienes Somos/SobreNosotros";
import { RouterLayout } from "./components/RouterLayout";
import Capacitaciones from "./pages/capacitaciones/Capacitaciones";
import Contacto from "./pages/contacto/Contacto";
import NuestrasAplicaciones from "./pages/Nuestras Aplicaciones/NuestrasAplicaciones";
import HROneClick from "./pages/HR One Click/HROneClick";
import QuaOneClick from "./pages/QUA One Click/QuaOneClick";
import SgrOneClick from "./pages/SGR One Click/SgrOneClick";
import CmOneClick from "./pages/CM One Click/CmOneClick";
import HrOneClickEducativa from "./pages/HR One Click Educativa/HrOneClickEducativa";
import DynamicsCRM365 from "./pages/Dynamics CRM 365/DynamicsCRM365";
import AvalOneClick from "./pages/AVAL One Click/AvalOneClick";
import PoliticaPrivacidad from "./pages/politica de privacidad/PoliticaPrivacidad";
import FormularioContacto from "./pages/contacto/FormularioContacto";

export const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<RouterLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/quienes-somos" element={<SobreNosotros />} />
        <Route path="/capacitaciones" element={<Capacitaciones />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/aplicaciones" element={<NuestrasAplicaciones />} />
        <Route path="/people-one-click" element={<HROneClick />} />
        <Route path="/qua-one-click" element={<QuaOneClick />} />
        <Route path="/sgr-one-click" element={<SgrOneClick />} />
        <Route path="/cm-one-click" element={<CmOneClick />} />
        <Route path="/people-one-click-educativa" element={<HrOneClickEducativa />} />
        <Route path="/dynamics-CRM-365" element={<DynamicsCRM365 />} />
        <Route path="/aval-one-click" element={<AvalOneClick />} />
        <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
      </Route>
      <Route path="/formulario-contacto" element={<FormularioContacto />} />
    </Routes>
  );
};
